import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

const PreviewCompatibleImage = ({ imageInfo }) => {
  const { alt = '', childImageSharp, image, style, classes } = imageInfo

  if (!!image && !!image.childImageSharp) {
    return (
      <Img style={style} fluid={image.childImageSharp.fluid} alt={alt} className={classes} />
    )
  }

  if (!!childImageSharp) {
    return <Img style={style} fluid={childImageSharp.fluid} alt={alt} className={classes} />
  }

  if (!!image && typeof image === 'string')
    return <img style={style} src={image} alt={alt} className={classes} />

  return null
}

PreviewCompatibleImage.propTypes = {
  imageInfo: PropTypes.shape({
    alt: PropTypes.string,
    childImageSharp: PropTypes.object,
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    style: PropTypes.object,
    classes: PropTypes.string
  }).isRequired,
}

export default PreviewCompatibleImage
